import React, { useState } from 'react';
import { useT } from '../i18n';
interface SlideFiveProps {
  ctaOption: string | null;
  onBack: () => void;
}
interface FormData {
  name: string;
  role: string;
  clinic: string;
  address: string;
  email: string;
  phone: string;
  consent: boolean;
}
export function SlideFive({
  ctaOption,
  onBack
}: SlideFiveProps) {
  const {
    t
  } = useT();
  const [form, setForm] = useState<FormData>({
    name: '',
    role: '',
    clinic: '',
    address: '',
    email: '',
    phone: '',
    consent: false
  });
  const [submitted, setSubmitted] = useState(false);
  const isWebMeeting = ctaOption === 'web-meeting';
  const heading = isWebMeeting ? t('form.headingMeeting') : t('form.headingMaterial');
  const subheading = isWebMeeting ? t('form.subMeeting') : t('form.subMaterial');
  const handleChange = (field: keyof FormData, value: string | boolean) => {
    setForm(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const isValid = form.name.trim() && form.email.trim() && form.clinic.trim() && form.consent;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isValid) return;
    console.log('Form submitted:', {
      ctaOption,
      ...form
    });
    setSubmitted(true);
  };
  if (submitted) {
    return <div className="flex flex-col h-full w-full justify-center items-center animate-fade-in-up" data-id="element-140">
        <div className="w-16 h-16 rounded-full bg-solventum-primary/20 border-2 border-solventum-primary flex items-center justify-center mb-6" data-id="element-141">
          <svg className="w-8 h-8 text-solventum-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-142">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" data-id="element-143" />
          </svg>
        </div>
        <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-3 text-center" data-id="element-144">
          {t('form.thankYou')}
        </h2>
        <p className="text-white/70 font-body text-center text-lg mb-2" data-id="element-145">
          {isWebMeeting ? t('form.thankMeeting') : t('form.thankMaterial')}
        </p>
        <p className="text-solventum-secondary font-body text-center text-sm" data-id="element-146">
          {t('form.thankFooter')}
        </p>
      </div>;
  }
  return <div className="flex flex-col h-full w-full justify-center animate-fade-in-up" data-id="element-147">
      {/* Back button */}
      <button onClick={onBack} className="self-start mb-4 flex items-center text-solventum-secondary hover:text-white transition-colors duration-200 text-sm font-body group" aria-label="Go back" data-id="element-148">
        <svg className="w-4 h-4 mr-1.5 transition-transform duration-200 group-hover:-translate-x-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-149">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" data-id="element-150" />
        </svg>
        {t('back')}
      </button>

      <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-2 text-center" data-id="element-151">
        {heading}
      </h2>
      <p className="text-solventum-secondary font-body text-center mb-8 text-sm" data-id="element-152">
        {subheading}
      </p>

      <form onSubmit={handleSubmit} className="w-full space-y-4" data-id="element-153">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-154">
          <div data-id="element-155">
            <label className="block text-white/70 text-xs font-body mb-1.5" htmlFor="name" data-id="element-156">
              {t('form.name')} <span className="text-solventum-primary" data-id="element-157">*</span>
            </label>
            <input id="name" type="text" required value={form.name} onChange={e => handleChange('name', e.target.value)} className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white font-body text-sm placeholder-white/30 focus:outline-none focus:border-solventum-primary focus:ring-1 focus:ring-solventum-primary/50 transition-colors" placeholder={t('form.namePlaceholder')} data-id="element-158" />
          </div>
          <div data-id="element-159">
            <label className="block text-white/70 text-xs font-body mb-1.5" htmlFor="role" data-id="element-160">
              {t('form.role')}
            </label>
            <input id="role" type="text" value={form.role} onChange={e => handleChange('role', e.target.value)} className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white font-body text-sm placeholder-white/30 focus:outline-none focus:border-solventum-primary focus:ring-1 focus:ring-solventum-primary/50 transition-colors" placeholder={t('form.rolePlaceholder')} data-id="element-161" />
          </div>
        </div>

        <div data-id="element-162">
          <label className="block text-white/70 text-xs font-body mb-1.5" htmlFor="clinic" data-id="element-163">
            {t('form.clinic')} <span className="text-solventum-primary" data-id="element-164">*</span>
          </label>
          <input id="clinic" type="text" required value={form.clinic} onChange={e => handleChange('clinic', e.target.value)} className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white font-body text-sm placeholder-white/30 focus:outline-none focus:border-solventum-primary focus:ring-1 focus:ring-solventum-primary/50 transition-colors" placeholder={t('form.clinicPlaceholder')} data-id="element-165" />
        </div>

        <div data-id="element-166">
          <label className="block text-white/70 text-xs font-body mb-1.5" htmlFor="address" data-id="element-167">
            {t('form.address')}
          </label>
          <input id="address" type="text" value={form.address} onChange={e => handleChange('address', e.target.value)} className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white font-body text-sm placeholder-white/30 focus:outline-none focus:border-solventum-primary focus:ring-1 focus:ring-solventum-primary/50 transition-colors" placeholder={t('form.addressPlaceholder')} data-id="element-168" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-169">
          <div data-id="element-170">
            <label className="block text-white/70 text-xs font-body mb-1.5" htmlFor="email" data-id="element-171">
              {t('form.email')}{' '}
              <span className="text-solventum-primary" data-id="element-172">*</span>
            </label>
            <input id="email" type="email" required value={form.email} onChange={e => handleChange('email', e.target.value)} className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white font-body text-sm placeholder-white/30 focus:outline-none focus:border-solventum-primary focus:ring-1 focus:ring-solventum-primary/50 transition-colors" placeholder="your@email.com" data-id="element-173" />
          </div>
          <div data-id="element-174">
            <label className="block text-white/70 text-xs font-body mb-1.5" htmlFor="phone" data-id="element-175">
              {t('form.phone')}
            </label>
            <input id="phone" type="tel" value={form.phone} onChange={e => handleChange('phone', e.target.value)} className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white font-body text-sm placeholder-white/30 focus:outline-none focus:border-solventum-primary focus:ring-1 focus:ring-solventum-primary/50 transition-colors" placeholder={t('form.phonePlaceholder')} data-id="element-176" />
          </div>
        </div>

        {/* Consent */}
        <div className="pt-2" data-id="element-177">
          <label className="flex items-start gap-3 cursor-pointer group" data-id="element-178">
            <div className="relative flex-shrink-0 mt-0.5" data-id="element-179">
              <input type="checkbox" checked={form.consent} onChange={e => handleChange('consent', e.target.checked)} className="sr-only peer" required data-id="element-180" />
              <div className="w-5 h-5 rounded border-2 border-white/30 bg-white/5 peer-checked:bg-solventum-primary peer-checked:border-solventum-primary transition-all duration-200 flex items-center justify-center" data-id="element-181">
                {form.consent && <svg className="w-3 h-3 text-solventum-bg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-182">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" data-id="element-183" />
                  </svg>}
              </div>
            </div>
            <span className="text-white/60 text-xs font-body leading-relaxed group-hover:text-white/80 transition-colors" data-id="element-184">
              {t('form.consent')}
              <br data-id="element-185" />
              <span className="text-solventum-secondary underline mt-1 inline-block" data-id="element-186">
                {t('form.privacy')}
              </span>
              <span className="text-solventum-primary" data-id="element-187"> *</span>
            </span>
          </label>
        </div>

        {/* Submit */}
        <div className="pt-3" data-id="element-188">
          <button type="submit" disabled={!isValid} className={`w-full font-headline font-extrabold py-4 px-6 rounded-xl transition-all duration-200 text-lg ${isValid ? 'bg-solventum-primary hover:bg-[#04c444] text-solventum-bg shadow-[0_0_15px_rgba(5,221,77,0.2)] cursor-pointer' : 'bg-white/10 text-white/30 cursor-not-allowed'}`} data-id="element-189">
            {isWebMeeting ? t('form.submitMeeting') : t('form.submitMaterial')}
          </button>
        </div>
      </form>
    </div>;
}